"use client";

import Address from "@client/components/lead-form/steps/address";
import type getLeadSubmissionDraft from "@server/front-end-api/getLeadSubmissionDraft";

type leadSubmissionDraftResponseData = Awaited<
	ReturnType<typeof getLeadSubmissionDraft>
>["data"];
interface Props {
	legendOverride?: string;
	leadSubmissionDraftData?: leadSubmissionDraftResponseData;
}

export default function AddressNew({ leadSubmissionDraftData }: Props) {
	const legendFallback = "What is your street address?";

	const validZipCode: string = leadSubmissionDraftData?.data?.zipCodeValid
		? (leadSubmissionDraftData?.data?.zipCode as string)
		: "";
	const zipCodeFromUser: string =
		(leadSubmissionDraftData?.data?.zipCode as string) || "";

	const cityFromSmarty: string =
		(leadSubmissionDraftData?.data?.city as string) || "";
	const stateFromSmarty: string =
		(leadSubmissionDraftData?.data?.state as string) || "";

	return (
		<Address
			validZipCode={validZipCode}
			zipCodeFromUser={zipCodeFromUser}
			cityFromSmarty={cityFromSmarty}
			stateFromSmarty={stateFromSmarty}
			legendOverride={legendFallback}
		/>
	);
}
